
import { observable } from "micro-observables";

export const alternativeHaloVisible = observable(false);

export const showAlternativeHalo = (): void => {
  alternativeHaloVisible.set(true);
};

export const hideAlternativeHalo = (): void => {
  alternativeHaloVisible.set(false);
};

export const alternativePanelQuickstartGuideRequested = observable(false);

export const requestAlternativePanelQuickstartGuide = (): void => {
  alternativePanelQuickstartGuideRequested.set(true);
};

export const clearAlternativePanelQuickstartGuide = (): void => {
  alternativePanelQuickstartGuideRequested.set(false);
};


export const alternativeGuide3ForceVisible = observable(false);
export const showAlternativeGuide3 = (): void => alternativeGuide3ForceVisible.set(true);
export const hideAlternativeGuide3 = (): void => alternativeGuide3ForceVisible.set(false);

export const alternativeGuide3WasCompleted = observable(false);
export const setAlternativeGuide3WasCompleted = (): void => alternativeGuide3WasCompleted.set(true);
export const resetAlternativeGuide3 = (): void => {
  alternativeGuide3ForceVisible.set(false);
  alternativeGuide3WasCompleted.set(false);
};